import React, { Component } from 'react';
import { Link } from 'react-router';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Input, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import BinForm from '../../containers/Inventories/binForm';

//import {buttonStyle, marginTopStyle, centerStyle, descriptionStyle} from '../Common/style'

const renderSearchField = props => <Input {...props.input} standalone type='text' placeholder='Search Bin...' />;

class ZoneDetail extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,
            zoneOpen: false,
            binOpen: false,
            confirmOpen: false,
            selectedBin: null,
        };

        this.handleResize = this.handleResize.bind(this);
        this.searchBins = this.searchBins.bind(this);
        this.openZone = this.openZone.bind(this);
        this.closeZone = this.closeZone.bind(this);
        this.openBin = this.openBin.bind(this);
        this.closeBin = this.closeBin.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        if (!this.props.currentZone) this.context.router.push('/warehouses');
        else this.props.fetchZoneDetail(this.props.currentZone);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton });
    }

    openZone() { this.setState({ zoneOpen: true }); }
    closeZone() { this.setState({ zoneOpen: false }); }

    openBin() { this.setState({ binOpen: true }); }
    closeBin() { this.setState({ binOpen: false }); }

    openConfirm = (binID) => {
      this.setState({
        confirmOpen: true,
        selectedBin: binID,
      });
    }

    closeConfirm = () => {
      this.setState({
        confirmOpen: false,
        selectedBin: null,
      });
    }

    viewBin(id) {
        this.props.resetCurrentBin();
        this.props.selectBin(id);
        this.openBin();
    }

    editBin(id) {
        this.props.resetCurrentBin();
        this.props.selectBin(id);
        this.openBin();
    }

    createBin(e) {
      e.preventDefault();
      this.props.resetCurrentBin();
      this.openBin();
    }

    searchBins() {
        const { fetchZoneDetail, searchBins, nameValue, currentZone } = this.props;
        if (!nameValue) fetchZoneDetail(currentZone);
        else searchBins(nameValue);
    }

    deleteBin(id) {
      this.props.resetCurrentBin();
      this.openConfirm(id);
      // this.setState({ selectedBin: id });
    }

    handleConfirmDelete = () => {
      if (this.state.selectedBin) {
        this.props.deleteBin(this.state.selectedBin)
          .then(() => {
            if (!this.props.currentZone) {
              this.context.router.push('/warehouses');
            } else {
              this.props.fetchZoneDetail(this.props.currentZone);
            }
          });
      }
      this.closeConfirm();
    }

    renderZoneDetail() {
        const { detailError, detailIsLoading, currentZoneDetail } = this.props;
        if (detailIsLoading && !detailError) {
          return <Spinner className='marginTopStyle' />;
        } else if (detailError) {
          return <div className='alert alert-danger'>{JSON.stringify(detailError) }</div>;
        } else if (currentZoneDetail) {
          const { Name, Description, WarehouseZone_id: warehouseZoneId } = currentZoneDetail;
          return (
            <div>
              <Row>
                <Col sm={12}>
                  <h4><Translate value="zone" />: {Name || <Translate value="name" /> }</h4>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <Translate value="warehouse_zone_id" />: { warehouseZoneId }
                </Col>
              </Row>
              <Row className='marginTopStyle'>
                <Col sm={12}>
                  <em className='fa fa-building-o marginRightStyle' />{Description || <Translate value="description" />}
                </Col>
              </Row>
            </div>
          );
        }
        return undefined;
    }

    renderProducts(bin) {
      const products = bin.Product;
      if (products) {
        return products.map(product => (
            <Row className='marginTopStyle'><Col sm={12} style={{ color: 'blue' }}> { product.Name } </Col></Row>
          )
        );
      }
      return undefined;
    }

    renderBins() {
        const { bins, detailError, detailIsLoading } = this.props;
        if (detailIsLoading && !detailError) {
          return <Spinner className='marginTopStyle' />;
        } else if (detailError) {
          return <div className='alert alert-danger'>{JSON.stringify(this.props.detailError)}</div>;
        }
        if (bins) {
          return bins.map((bin) => {
            const { Name, Description, WarehouseBin_id: warehouseBinId } = bin;
            return (
              <Col sm={3}>
                <Panel style={{ overflowY: 'scroll', height: this.state.tableHeight / 2 }} >
                  <Row>
                    {/* <Col sm={9} style={{backgroundColor: Description, height: '1em'}}></Col> */}
                    {
                      this.props.deleteBinFailureError && this.state.selectedBin === warehouseBinId &&
                      <div className='alert alert-danger'>{this.props.deleteBinFailureError}</div>
                    }
                    {
                      this.props.deleteBinSuccess && this.state.selectedBin === warehouseBinId &&
                      <div className='alert alert-success'><Translate value="deleted" /></div>
                    }
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <Row>
                        <Col sm={9}>
                          <a onClick={() => this.viewBin(bin)} style={{ cursor: 'pointer' }}>
                            <em className='fa fa-institution marginRightStyle' />
                            <b><Translate value="bin" /> { Name || <Translate value="name" /> }</b>
                          </a>
                        </Col>
                        <Col sm={3}>
                          <em
                            className='fa fa-trash buttonStyle'
                            onClick={() => this.deleteBin(warehouseBinId)}
                          />
                          <em
                            className='fa fa-pencil buttonStyle'
                            onClick={() => this.editBin(bin)}
                          />
                        </Col>
                      </Row>
                      {/*
                        <Row>
                          <Col sm={12}>
                            <label><Translate value="warehouse_bin_id" />: </label>{WarehouseBin_id}
                          </Col>
                        </Row>
                      */}
                      <Row>
                        <Col sm={12}>
                          <label><Translate value="description" />: </label>
                          <em className='fa fa-building marginLeftStyle marginRightStyle' />
                          { Description || '-' }
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          <label><Translate value="products" />:</label>
                        </Col>
                      </Row>
                      {this.renderProducts(bin)}
                    </Col>
                  </Row>
                </Panel>
              </Col>
            );
          });
        }
    }

    renderFormTitle() {
        if (this.props.currentBin) {
          return <Translate value="edit_bin" />;
        }
        return <Translate value="add_a_new_bin" />;
    }

    render() {
        const { handleSubmit } = this.props;
        const height = (this.state.tableHeight + 50).toString();
        const tableCollapseFix = { height };
        const createDialogStyle = {
            width: '600px',
            marginLeft: '-15%',
        };
        return (
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="warehouse_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active='true'>
                  <Translate value="zone_detail_view" /> {'|'} <Translate value="zone" />
                </Breadcrumb.Item>
              </Breadcrumb>
              <Grid fluid='true' id='zone-detail'>
                <Row>
                  <Panel>
                    <form method='get' action='#' onSubmit={handleSubmit(this.searchBins.bind(this))}>
                      <Row>
                        <Col sm={12}>
                          <Link
                            to='/warehouses/detail'
                            className='btn btn-green buttonStyle'
                          >
                            <em className='fa fa-mail-reply' />
                          </Link>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col sm={12}>
                          {this.renderZoneDetail() }
                        </Col>
                      </Row>
                      <hr className='marginRightStyle' />
                      <Row>
                        <Col sm={12}>
                          <Row>
                            <Col sm={12}>
                              <h4><Translate value="all_bins" /></h4>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={12}>
                              <Row>
                                <Col sm={3}>
                                  <Field name='BinName' component={renderSearchField} />
                                </Col>
                                <Col sm={2}>
                                  <Button type='submit' ><em className='fa fa-search' /></Button>
                                </Col>
                                <Col sm={7}>
                                  <Button
                                    onClick={(event) => this.createBin(event)}
                                    className='btn btn-primary pull-right'
                                  >
                                    <em className='fa fa-plus marginRightStyle' /><Translate value="add_new_bin" />
                                  </Button>
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Panel style={tableCollapseFix}>
                                  <Row style={{ overflowY: 'scroll', maxHeight: this.state.tableHeight }}>
                                    {this.renderBins() }
                                  </Row>
                                </Panel>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </form >
                  </Panel>

                  <SkyLightStateless isVisible={this.state.binOpen} onCloseClicked={this.closeBin} title={this.renderFormTitle()}>
                    <BinForm closeG={this.closeBin} />
                  </SkyLightStateless>
                  <SkyLightStateless
                    dialogStyles={createDialogStyle}
                    isVisible={this.state.confirmOpen}
                    onCloseClicked={this.closeConfirm}
                    title={<Translate value="delete_bin" />}
                  >
                    <Row className='centerStyle'>
                      <h4><Translate value="msg_confirm_delete" /></h4>
                    </Row>
                    <Row className='centerStyle'>
                      <Button
                        bsStyle='primary'
                        className='mt mr'
                        onClick={this.handleConfirmDelete}
                      >
                        <em className='fa fa-check' /><Translate value="Confirm" />
                      </Button>
                      <Button
                        bsStyle='danger'
                        className='mt mr'
                        onClick={this.closeConfirm}
                      >
                        <em className='fa fa-close' /><Translate value="Cancel" />
                      </Button>
                    </Row>
                  </SkyLightStateless>
                </Row>
              </Grid>
            </ContentWrapper >
        );
    }
}

export default ZoneDetail;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/zoneDetail.jsx